import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';
import { Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showUser, setShowUser] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(username, password);
      toast.success('مرحباً بك!');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'فشل تسجيل الدخول');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-gray-50 dark:bg-dark-deeper font-[Tajawal] transition-colors duration-300" dir="rtl">
      {/* Subtle background glow */}
      <div className="absolute top-[-15%] right-[-10%] w-[500px] h-[500px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(155,142,196,0.12) 0%, transparent 70%)' }} />
      <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(155,142,196,0.1) 0%, transparent 70%)' }} />

      <div className="w-full max-w-[440px] relative z-10 px-4">
        <div className="bg-white/95 dark:bg-white/5 backdrop-blur-xl rounded-[24px] p-10 md:p-12 shadow-[0_20px_60px_rgba(0,0,0,0.08)] dark:shadow-[0_20px_60px_rgba(0,0,0,0.3)] border border-white/40 dark:border-white/10 transition-all">

          {/* Logo */}
          <div className="text-center mb-10">
            <div className="mb-4 flex justify-center">
              <img src="/logos/ms-media-icon.svg" alt="MS MEDIA" className="w-16 h-16 drop-shadow-xl" />
            </div>
            <h1 className="text-3xl font-black tracking-widest text-dark dark:text-gray-100 m-0">
              MS <span className="text-primary-dark">MEDIA</span>
            </h1>
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 tracking-wide">
              نظام المحاسبة والإدارة
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* username */}
            <div>
              <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">اسم المستخدم</label>
              <div className="relative">
                <input
                  type="text"
                  value={username} onChange={e => setUsername(e.target.value)}
                  placeholder="admin"
                  autoComplete="username"
                  className="w-full py-3 px-4 bg-white dark:bg-dark-deeper text-dark dark:text-gray-100 rounded-xl border-2 border-gray-200 dark:border-white/10 focus:border-primary dark:focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all outline-none"
                />
              </div>
            </div>

            {/* password */}
            <div>
              <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">كلمة المرور</label>
              <div className="relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  className="w-full py-3 px-4 pl-12 bg-white dark:bg-dark-deeper text-dark dark:text-gray-100 rounded-xl border-2 border-gray-200 dark:border-white/10 focus:border-primary dark:focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all outline-none"
                />
                <button type="button" onClick={() => setShowPass(!showPass)} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-primary transition-colors">
                  {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className={`w-full py-3.5 mt-2 rounded-xl font-bold text-white transition-all shadow-lg shadow-primary/20 ${loading ? 'bg-gray-400 cursor-not-allowed opacity-70 shadow-none' : 'bg-gradient-to-l from-primary-dark to-primary hover:opacity-90 hover:-translate-y-0.5'}`}>
              {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}
